export const ELIGIBLE = 'ELIGIBLE';
export const SD = 'DSICLAIMER_CONFIRM_REQUIRED';
export const SL = 'RESIDENCE_ASSETS_RESTRICTION';
export const SP = 'PRIIPS_ASSETS_RESTRICTION';
